
import styled from "styled-components";
import { useContext } from "react";
import { TifynFooter } from "@tiffin/components";
import { ViewContext } from "../Contexts";
import { MenuBar } from "../components/MenuBar";
import { useAppSelector } from "../hooks";
import TifynLogo from "../assets/images/tifyn-logo.png"
import { NavBar } from "../components/NavBar";
import { AccountInfo } from "../components/account/AccountInfo";
import { IonIcon } from "@ionic/react";
import { personOutline } from "ionicons/icons"

export const AccountDetails = styled(BaseAccountDetails)`
  display: grid;
  grid-template-columns: auto 1fr;
  height: 100%;

  .header {
    background: #fff;
    padding: 20px;
    font-size: var(--font-size-medium);
    font-weight: 600;
    display: flex;
    align-items: center;
    gap: 5px;

    ion-icon {
      font-size: var(--font-size-xlarge);
    }
  }

  .page {
    height: calc(var(--vh, 1vh) * 100);
    overflow: auto;
    display: flex;
    flex-direction: column;

    @media (max-width:768px) {
      padding-bottom: 70px;
    }

    .container {
      background: #fff;
      margin: 10px;
      flex-grow: 1;
      border-radius: 8px;
    }
  }
`

interface IAccountDetails {
  className?: string
}

function BaseAccountDetails({className}: IAccountDetails) {

  const partner = useAppSelector((state) => state.store)
  const view = useContext(ViewContext);

  return (
    <div className={className}>
      {
        view === "web" && <NavBar />
      }
      <div className="page">
        {
          partner.details &&
          <>
            <div className="header">
              <IonIcon icon={personOutline} />
              <span>Account</span>
            </div>
            <div className="container">
              <AccountInfo />
            </div>
            {
              view === "web" &&
                <TifynFooter
                  logoAlt="Tifyn Logo"
                  logoSrc={TifynLogo}
                />
            }
          </>
        }
      </div>
      {
        view === "mobile" && <MenuBar />
      }
    </div>
  )
}